module.exports = __webpack_public_path__ + "img/rancher-logo.ab37084b.svg";